import React, {useState} from 'react'
import {DimensionRow} from "./SavedDimensionRow";
import {Modal, ModalBody, ModalHeader, Row, Col, Button, Table} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import LanguageSelector from "../../components/LanguageSelector";
import ExcelDownload from "../DetailUtility/ExcelDownload";

export default function GroupCardModal({group, dimensions, reloadListing}) {
  const [language, setLanguage] = useState('it');
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  return (
    <>
      <Button color="info" onClick={toggle}>
        <FontAwesomeIcon icon="fas fa-info-circle" onClick={() => toggle} /> Dettagli
      </Button>
      <Modal isOpen={modal} toggle={toggle} scrollable>
        <ModalHeader toggle={toggle} className="justify-content-center">
          <h3>{group.name} - {language.toUpperCase()}</h3>
        </ModalHeader>
        <ModalBody className="bg-secondary">
          <Row className="justify-content-around align-center">
            <Col md={8}>
              <LanguageSelector language={language} setLanguage={setLanguage}/>
            </Col>
            <Col md={4}>
              <ExcelDownload
                dim={group.name}
                language={language}
                loader={false} // there's no need to wait for a load here
                mode={"saved"}
              />
            </Col>
          </Row>
          <br/>
          <Row className="justify-content-center">
            <h3>Dimensioni</h3>
            <Table striped responsive>
              <thead>
                <tr>
                  <th>
                    Nome
                  </th>
                  <th className="text-center">
                    Unica Lingua
                  </th>
                  <th className="text-center">
                    Elimina
                  </th>
                </tr>
              </thead>
              <tbody>
                {group.dimensions.map((dimension, index) => (
                  <DimensionRow
                    dim={dimension}
                    group={group}
                    savedDimensions={dimensions}
                    reloadGroupRow={reloadListing}
                    is_sub={group.is_sub}
                    language={language}
                    key={dimension.name}
                  />
                ))}
              </tbody>
            </Table>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}
